<h2 mat-dialog-title>{{ isEdit ? 'Sonstigen Erlös bearbeiten' : 'Sonstigen Erlös anlegen' }}</h2>
<mat-dialog-content class="dialog-content">
    <p class="hint" *ngIf="locked">Beleg ist in der Primanota – nur Ausgleichen möglich.</p>
    <div class="one-row">
        <mat-form-field>
            <mat-label>Partner</mat-label>
            <mat-select [(ngModel)]="partnerArt" (selectionChange)="onPartnerArtChange()" [disabled]="locked">
                <mat-option value="INSTITUTION">Institution</mat-option>
                <mat-option value="DEBITOR">Sonstiger Debitor</mat-option>
            </mat-select>
        </mat-form-field>
        <div class="flex" *ngIf="partnerArt === 'INSTITUTION'">
            <kiene-autocomplete
                [apiUrl]="'institution/'"
                [displayFields]="['bezeichnung']"
                [focus]="false"
                [kieneObject]="institution"
                [params]="aktivParams"
                [placeholder]="'Institution (TSK/Kammer)'"
                [required]="true"
                (elementSelected)="institution = $event"
            ></kiene-autocomplete>
        </div>
        <div class="flex" *ngIf="partnerArt === 'DEBITOR'">
            <kiene-autocomplete
                [apiUrl]="'sonstiger_debitor/'"
                [displayFields]="['bezeichnung']"
                [focus]="false"
                [kieneObject]="debitor"
                [params]="aktivParams"
                [placeholder]="'Sonstiger Debitor'"
                [required]="true"
                (elementSelected)="debitor = $event"
            ></kiene-autocomplete>
        </div>
    </div>
    <div class="one-row">
        <div class="flex">
            <kiene-autocomplete
                [apiUrl]="'kunde/'"
                [displayFields]="['kunde_nr_intern', 'bezeichnung']"
                [focus]="false"
                [kieneObject]="kunde"
                [placeholder]="'Landwirt (optional)'"
                [required]="false"
                (elementSelected)="kunde = $event"
            ></kiene-autocomplete>
        </div>
        <mat-form-field>
            <mat-label>Belegnr</mat-label>
            <input matInput [formControl]="belegnrCtrl" />
        </mat-form-field>
    </div>
    <div class="one-row">
        <mat-form-field>
            <mat-label>Datum</mat-label>
            <input matInput [matDatepicker]="dp" [formControl]="datumCtrl" />
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Leistung von</mat-label>
            <input matInput [matDatepicker]="dv" [formControl]="leistVonCtrl" />
            <mat-datepicker-toggle matSuffix [for]="dv"></mat-datepicker-toggle>
            <mat-datepicker #dv></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Leistung bis</mat-label>
            <input matInput [matDatepicker]="db" [formControl]="leistBisCtrl" />
            <mat-datepicker-toggle matSuffix [for]="db"></mat-datepicker-toggle>
            <mat-datepicker #db></mat-datepicker>
        </mat-form-field>
        <div style="padding-top: 12px">
            <mat-checkbox [formControl]="freigegebenCtrl">Freigeben (Journal)</mat-checkbox>
        </div>
    </div>
    <h3>Steuerzeilen (Default 0 %)</h3>
    <table class="ka-table">
        <thead>
            <tr>
                <th>Bezeichnung</th>
                <th>Netto</th>
                <th>MwSt</th>
                <th>Erlöskonto 86xx</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let p of preise; let i = index">
                <td>
                    <input class="txt" [(ngModel)]="p.bezeichnung" [disabled]="locked" />
                </td>
                <td>
                    <input class="num" type="number" step="0.01" [(ngModel)]="p.kosten_netto" [disabled]="locked" />
                </td>
                <td>
                    <select [(ngModel)]="p.mwstsatz" [disabled]="locked">
                        <option *ngFor="let m of mwstSaetze" [ngValue]="m">{{ m }} %</option>
                    </select>
                </td>
                <td>
                    <kiene-autocomplete
                        [apiUrl]="'fibu_konto/'"
                        [displayFields]="['konto_nr', 'bezeichnung']"
                        [focus]="false"
                        [kieneObject]="p.erloes"
                        [params]="erloesParams"
                        [placeholder]="'86xx'"
                        (elementSelected)="p.erloes = $event"
                    ></kiene-autocomplete>
                </td>
                <td>
                    <button mat-icon-button type="button" (click)="removePreis(i)" [disabled]="locked">
                        <mat-icon>close</mat-icon>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
    <button mat-stroked-button type="button" (click)="addPreis()" [disabled]="locked">Zeile hinzufügen</button>
    <mat-form-field class="full" style="margin-top: 12px">
        <mat-label>Kommentar</mat-label>
        <textarea matInput rows="2" [formControl]="kommentarCtrl"></textarea>
    </mat-form-field>

    <div class="pdf-block" *ngIf="!locked">
        <button mat-flat-button color="accent" type="button" (click)="openFileSelector()">
            Beleg als PDF hinzufügen
        </button>
        <input
            #fileSelector
            type="file"
            accept="application/pdf"
            style="display: none"
            (change)="handleFiles($event)"
        />
        <span class="pdf-hint" *ngIf="existingPdfId && filesToUpload.length === 0">
            PDF bereits vorhanden (wird bei neuem Upload ersetzt)
        </span>
        <div *ngIf="filesToUpload.length > 0" class="pdf-file one-row">
            <mat-icon>insert_drive_file</mat-icon>
            <span>{{ filesToUpload[0]?.name }}</span>
            <mat-icon *ngIf="filesUploadStatus[0] === 1" color="primary">check</mat-icon>
            <mat-icon *ngIf="filesUploadStatus[0] === 2" color="warn">warning</mat-icon>
            <mat-progress-spinner
                *ngIf="filesToUpload.length > 0 && saving"
                [diameter]="28"
                [value]="filesProgressValues[0] || 0"
                mode="determinate"
            ></mat-progress-spinner>
            <button mat-icon-button type="button" (click)="removeFile()" [disabled]="saving">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()" [disabled]="saving">Abbrechen</button>
    <ng-container *kienePermission="[17226]">
        <ng-container *ngIf="isEdit && status === 1">
            <button mat-stroked-button type="button" (click)="ausgleichen()" [disabled]="saving">
                Ausgleichen
            </button>
        </ng-container>
    </ng-container>
    <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="!isValid() || locked || saving"
        (click)="save()"
    >
        Speichern
    </button>
</mat-dialog-actions>
